import $ from 'jquery';
import { emitter } from './emitter';


/**
 * news page grid
 *
 * @module news-grid
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-08-30 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-12-02 using ChatGPT
 */

class NewsGrid {
  constructor(element) {
    this.$el = $(element);

    this.setupBinds();
    this.setupLoadMore();
    // Log removed: 'NewsGrid : Initialized'
  }

  setupBinds() {
    this.$filterableObjects = this.$el.find('.filter__object');
    emitter.on('updateFilter', this.handleFilter.bind(this));
  }

  setupLoadMore() {
    const $button = this.$el.find('.loadMore');
    this.pageLinks = $button.data('links');
    if (this.pageLinks) {
      $button.on('click', () => this.onMoreClick());
    }
  }

  urlFilter(state) {
    let searchParam = '';
    let optionParam = '';

    const dropdowns = Object.keys(state.dropdowns);

    if (state.search) {
      searchParam = `search=${state.search}`;
    }

    dropdowns.forEach((di) => {
      const ampersand = searchParam === '' && optionParam === '' ? '' : '&';
      if (state.dropdowns[di]) {
        optionParam += `${ampersand}${di}=${state.dropdowns[di]}`;
      }
    });

    const urlParamsString = searchParam + optionParam;
    const url = `${window.location.href.split('?')[0]}${urlParamsString ? '?' + urlParamsString : ''}`;
    window.history.pushState('object or string', 'Title', url);
    return urlParamsString;
  }

  handleFilter(data) {
    const baseURL = window.location.origin; // This will be the CNAME domain
    const link = `${baseURL}/news?${this.urlFilter(data)} .results-container > *`;
    const $resultsContainer = this.$el.find('.results-container');
    $resultsContainer.load(link, () => {
      if(!$resultsContainer.children().length) {
        $resultsContainer.html('<p class="noContent">There are no news or events within your current search criteria, please try another</p>');
      }
      this.setupLoadMore();
    });
  }

  onMoreClick() {
    const baseURL = window.location.origin; // Get the base URL from the current location
    const $button = this.$el.find('.loadMore');
    let link;
  
    try {
      link = this.pageLinks.shift();
    } catch (e) {
      $button.hide();
      return;
    }
  
    if (this.pageLinks.length === 0) {
      $button.hide();
    }
  
    if (link) {
      const $container = $('<div></div>');
      const fullUrl = baseURL + link; // Combine base URL with the relative link
      $container.load(`${fullUrl} .filterableArea .card`, () => {
        $container.find('.card').appendTo('.filterableArea');
      });
    }
  }
}

export default NewsGrid;
